import { RouteObject } from "react-router-dom";
import WelcomePage from "../pages/welcomePage";
import { DomainProvider } from "@4uhub/lib4uhub";
import MyTotemPage from "../pages/4uTotem/MyTotem/MyTotemPage";
import MyTotem from "../pages/4uTotem/MyTotem/MyTotem";
import TotemDevicesPage from "../pages/4uTotem/TotemDevices/TotemDevicesPage";
import TotemDevice from "../pages/4uTotem/TotemDevices/TotemDevicesForm/TotemDevice";

const totem: RouteObject[] = [
  {
    index: true,
    element: <WelcomePage />,
  },
  {
    path: "applications/myTotens",
    element: (
      <DomainProvider value={{ domainName: "4utotem" }}>
        <MyTotemPage />
      </DomainProvider>
    ),
  },
  {
    path: "applications/myTotens/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "4utotem" }}>
        <MyTotem />
      </DomainProvider>
    ),
  },
  {
    path: "register/totemDevices",
    element: (
      <DomainProvider value={{ domainName: "totemdevice" }}>
        <TotemDevicesPage />
      </DomainProvider>
    ),
  },
  {
    path: "register/totemDevices/new",
    element: (
      <DomainProvider
        value={{ domainName: "totemdevice" }}
        actions={["Create"]}
      >
        <TotemDevice />
      </DomainProvider>
    ),
  },
  {
    path: "register/totemDevices/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "totemdevice" }}>
        <TotemDevice />
      </DomainProvider>
    ),
  },
];

export default totem;
